// extracted by mini-css-extract-plugin
export default {"resume":"About_resume__psnQ7","titleResume":"About_titleResume__dDDis","fadeInUp":"About_fadeInUp__5TaN9","resumeText":"About_resumeText__+ysp3"};